package com.artvending.warden.screens.scanner

import androidx.compose.runtime.Composable
import com.artvending.warden.Alignment
import com.artvending.warden.Column
import com.artvending.warden.MdCircularProgress
import com.artvending.warden.OutlinedButton
import com.artvending.warden.StackScope
import com.artvending.warden.Text_
import com.artvending.warden.goHome
import com.artvending.warden.settings
import com.artvending.warden.language
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.alignSelf
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.times

@Composable
fun StackScope.ScannerScreen_(model: ScannerScreenModel) {
	Column(weight = 1, space = settings.bigSpace) {
		Text_(language.SCAN_FROM_TABLET)
		
		if (!model.scanner.started) {
			Text_(language.LOAD_SCANNER, hAlignment = Alignment.center, marginTop = settings.bigSpace * 2, color = settings.opacityGray)
			MdCircularProgress { style { alignSelf(AlignSelf.Center); marginBottom(settings.bigSpace * 2) } }
		}
		
		if (model.showScanner)
			model.scanner.ScannerView { code ->
				model.showScanner = false
				model.qrCodeDetected(code)
			}
		
		if (model.scanner.started)
			OutlinedButton({ goHome() }, { style { alignSelf(AlignSelf.Center) } }) {
				org.jetbrains.compose.web.dom.Text(language.BACK)
			}
	}
}